import { EventEmitter, Injectable, Output, Inject } from '@angular/core';
import { ClassUser } from './class-user';

import { Registration } from './registration';
import { User } from './user';
import { RaceClassRaw } from './interfaces/race_class_raw.interface';

export class RaceClass {
  clUid: string;
  name: string = '';
  description: string = '';
  sortPosition: number = 9000;
  busyNumbers = [];
  city: string = '';
  customMapFileUid: string = '';
  customMapBounds: L.LatLngTuple[] = [];
  date: string = '';

  raceTime: number = 0;
  raceLaps: number = 0;
  flFinishAllAfterLeader: boolean = false;
  finishCloseTime: number = 0;
  finishCloseTimeByFirstStart: boolean = false;
  minLapTime: number = 30;
  checkpoints: string = '';

  numbersAssignedByOrg: boolean = false;
  minNumber: number = 0;
  maxNumber: number = 0;

  minAge: number = 0;
  maxAge: number = 0;
  allowedGender: number = 0;

  crewClass: boolean = false;
  maxMembers: number = 0;
  minMembers: number = 0;
  maxCompetitors: number = 0;

  registrations: Array<Registration> = [];
  crew: ClassUser[] = [];
  loading = false;
  rUid: string;

  get userCount() {
    return this.registrations.length;
  }

  get userLimit() {
    if (this.maxNumber && this.minNumber) {
      return this.maxNumber - this.minNumber + 1;
    } else {
      return null;
    }
  }

  checkDataUserForReg(user: User | null, raceDate: Date | undefined) {
    let blockreg = {
      limit: false,
      ageMin: false,
      ageMax: false,
      gender: false,
      error: false,
    };

    if (this.numbersAssignedByOrg && this.userLimit) {
      const limit = this.userLimit;
      const count = this.userCount;
      if (count >= limit) {
        blockreg.limit = true;
        blockreg.error = true;
      }
    }

    if (user?.birthdate) {
      if (user && this.minAge > 0 && user.getUserAge(raceDate) < this.minAge) {
        blockreg.ageMin = true;
        blockreg.error = true;
      }

      if (user && this.maxAge > 0 && user.getUserAge(raceDate) > this.maxAge) {
        blockreg.ageMax = true;
        blockreg.error = true;
      }
    }

    if (
      user &&
      user.gender != 0 &&
      this.allowedGender != 0 &&
      this.allowedGender != user.gender
    ) {
      blockreg.gender = true;
      blockreg.error = true;
    }

    return blockreg;
  }

  constructor(obj: RaceClassRaw) {
    this.clUid = obj.clUid;
    this.name = obj.name || '';
    this.description = obj.description || '';
    this.sortPosition = obj.sortPosition || 9000;
    this.busyNumbers = obj.busyNumbers = [];
    this.city = obj.city || '';
    this.date = obj.date = '';
    this.rUid = obj.rUid = '';

    this.raceTime = obj.raceTime || 0;
    this.raceLaps = obj.raceLaps || 0;
    this.flFinishAllAfterLeader = obj.flFinishAllAfterLeader || false;
    this.finishCloseTime = obj.finishCloseTime || 0;
    this.finishCloseTimeByFirstStart = obj.finishCloseTimeByFirstStart || false;
    this.minLapTime = obj.minLapTime || 30;
    this.checkpoints = obj.checkpoints
    ? obj.checkpoints.split('$').join(', ')
    : '';;

    this.numbersAssignedByOrg = obj.numbersAssignedByOrg || false;
    if (obj.minNumber && obj.maxNumber) {
      this.minNumber = obj.minNumber;
      this.maxNumber = obj.maxNumber;
    }

    this.minAge = obj.minAge || 0;
    this.maxAge = obj.maxAge || 0;
    this.allowedGender = obj.allowedGender || 0;

    this.crewClass = obj.crewClass || false;
    this.maxMembers = obj.maxMembers || 0;
    this.minMembers = obj.minMembers || 0;

    this.maxCompetitors = obj.maxCompetitors || 0;

    if (obj.customMapFileUid && obj.customMapBounds) {
      this.customMapFileUid = obj.customMapFileUid;
      const numbers = obj.customMapBounds.split(';');
      this.customMapBounds = [
        [Number(numbers[0]), Number(numbers[1])],
        [Number(numbers[2]), Number(numbers[3])],
      ];
    }
  }
}
